import React, {useState} from 'react';
import Header from "../../components/template-default/header";
import Content from "../../components/template-default/content";
import {ToastContainer} from "react-toastify";
import Loader from "../loader";
import Menu from "./menu";

const TemplateDefault = ({children, title, isLoading = false}) => {
    const [menusIsOpen, setMenusIsOpen] = useState(false);

    return (
        <>
            {isLoading && <Loader />}

            <Header title={title} menusIsOpen={menusIsOpen} setMenusIsOpen={setMenusIsOpen}/>
            <ToastContainer />

            <Menu menusIsOpen={menusIsOpen}/>

            <Content menusIsOpen={menusIsOpen}>
                {children}
            </Content>
        </>
    )
};

export default TemplateDefault;